import { ComponentType } from 'react';
import { TBooleanInNumber } from '~/types/main';

export enum MarketplaceFeatureKey {
  Foodics = 'foodics',
  Marn = 'marn',
  GoogleMaps = 'google_maps',
  TakerConnect = 'connect',
  Checkout = 'checkout',
  ApplePay = 'apple_pay',
  TakerGo = 'taker_go',
  GoogleTagManager = 'google_tag_manager',
  FeedUs = 'feedUs',
  Sap = 'SAP',
  Deliverect = 'deliverect',
  Fodo = 'FODO',
  Mobile = 'mobile',
  Kiosks = 'kiosks',
  Wallet = 'wallet',
  Cashback = 'cashback',
  Ramadan = 'ramadan',
  Franchise = 'franchise',
  Curbside = 'curbside',
  ComboDeals = 'combo_deals',
  ComboMeal = 'combo_meal',
  Emenu = 'e_menu',
  AdvancedPromocode = 'advanced_promocode',
  CrossSelling = 'cross_selling',
  PromoBanners = 'promo_banners',
  ProductFeed = 'product_feed',
  Webhook = 'webhook',
  TakerThreeSixty = 't360',
}

export enum MarketplaceFeatureType {
  All = 'all',
  Marketing = 'marketing',
  Menu = 'menu',
  Delivery = 'delivery',
  Franchise = 'franchise',
  Charity = 'charity',
  Pos = 'pos',
  Payment = 'payment',
  Ordering = 'ordering',
  Integrations = 'integrations',
}

export interface IMarketplaceFeatureParams {
  name: string;
  title?: string;
  description?: string;
  iconName?: string;
  backgroundColor?: string;
  extensionComponent: ComponentType | null;
  configLink: {
    href: string | null;
    path: string[];
    options?: {
      hideWhenDisabled?: boolean;
      hideEnableToggle?: boolean;
    };
  } | null;
}

export interface IMarketplaceFilters {
  type: MarketplaceFeatureType;
  showPurchased: boolean;
  search: string;
}

export type TMarketplaceUpdateParams = Partial<
  {
    [key in MarketplaceFeatureKey]: TBooleanInNumber;
  } & {
    wallet_currency: string;
    wallet_currency_ar: string;
    wallet_currency_en: string;
    wallet_addon_currency_id: string;
    is_wallet_usage_limit: TBooleanInNumber;
    wallet_usage_limit: number | null;
  }
>;

export const marketplaceFeatureCast = (data: any) => ({
  key: String(data.name) as MarketplaceFeatureKey,
  status: Boolean(data.status),
  isPurchased: Boolean(data.isPurchased),
  type: (Array.isArray(data.type) ? data.type : [data.type]) as string[],
  walletCurrency: data.wallet_currency ? String(data.currency_code) : '',
  walletCurrencyId: data.wallet_addon_currency_id !== undefined ? String(data.wallet_addon_currency_id) : '',
  walletCurrencyAr: data.wallet_currency_ar ? String(data.wallet_currency_ar) : '',
  walletCurrencyEn: data.wallet_currency ? String(data.wallet_currency) : '',
  isWalletUsageLimit: data.is_wallet_usage_limit ? (data.is_wallet_usage_limit as TBooleanInNumber) : undefined,
  walletUsageLimit: data.wallet_usage_limit ? String(data.wallet_usage_limit) : undefined,
  donationBranchId: data.donation_branch_id !== undefined ? Number(data.donation_branch_id) : undefined,
  franchise_unintegrated_branches: data.franchise_unintegrated_branches !== undefined ? Boolean(data.franchise_unintegrated_branches) : undefined,
});

export type TMarketplaceFeature = ReturnType<typeof marketplaceFeatureCast>;
